import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AsideDefault } from './components/aside/AsideDefault'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useLocation } from 'react-router-dom'
import {
  DrawerMessenger,
  InviteUsers,
  ThemeModeProvider,
} from '../partials'
import { MenuComponent } from '../assets/ts/components'

const MasterLayout = () => {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='page d-flex flex-row flex-column-fluid'>
          {
            !location.pathname.includes("usermap") && <AsideDefault />
          }
          <div className={location.pathname.includes("usermap") ? "d-flex flex-column flex-row-fluid" : "wrapper d-flex flex-column flex-row-fluid"} id='kt_wrapper'>
            {
              !location.pathname.includes("usermap") && <HeaderWrapper />
            }
            <div id='kt_content'
              className={location.pathname.includes("usermap") ? "d-flex flex-column flex-column-fluid" : "master-content d-flex flex-column flex-column-fluid"}
            >
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        <DrawerMessenger />
        <InviteUsers />
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }
